import * as React from 'react';
import cn from 'classnames';
import { SeatComfort } from '@websky/graphql';
import { useTheme } from '@websky/core/src/theme';
import { getSeatPrice } from '@websky/core/src/SeatMap/utils';
import { isFreeSeat as getIsFreeSeat } from '@websky/core/src/SeatMap/components/SeatMap/utils';
import SeatMapService from '@websky/core/src/SeatMap/components/SeatMapService/SeatMapService';
import SeatInfo from '@websky/core/src/SeatMap/components/SeatsInfo/SeatInfo/SeatInfo';
import Money from '@websky/core/src/Money';
import { getSeatColor } from '../SeatMapSeat/getSeatColor';
import css from './SeatMap.css';
const SeatMap = props => {
    const { SeatStyles: seatTheme } = useTheme('SeatMap');
    const renderSeat = (seat) => {
        return (React.createElement("button", { className: cn(seatTheme.seat, css.seat, getSeatColor(seat.rfisc), {
                [seatTheme.seat_standart]: seat.comfort === SeatComfort.Standart,
                [seatTheme.seat_business]: seat.comfort === SeatComfort.Comfort,
                [seatTheme.seat_preferred]: seat.comfort === SeatComfort.Preferred
            }), disabled: true },
            React.createElement("div", { className: seatTheme.number },
                React.createElement(Money, { moneyClassName: css.seatPrice, money: getSeatPrice(seat) }))));
    };
    const renderSeatInfoHeader = (groupServices) => () => {
        var _a;
        if (groupServices.length === 1) {
            const seatService = groupServices[0];
            const seatName = seatService === null || seatService === void 0 ? void 0 : seatService.name;
            const seatDescription = seatService === null || seatService === void 0 ? void 0 : seatService.description;
            return (React.createElement("div", { className: css.info },
                React.createElement("div", null, renderSeat(seatService)),
                React.createElement("div", { className: css.content },
                    seatName && React.createElement("div", { className: css.title }, seatName),
                    seatDescription && React.createElement("div", { className: css.description }, seatDescription))));
        }
        const sortedSeats = [...groupServices].sort((a, b) => {
            var _a, _b;
            if (getIsFreeSeat(a)) {
                return 1;
            }
            if (getIsFreeSeat(b)) {
                return -1;
            }
            const aPrice = ((_a = getSeatPrice(a)) === null || _a === void 0 ? void 0 : _a.amount) || 0;
            const bPrice = ((_b = getSeatPrice(b)) === null || _b === void 0 ? void 0 : _b.amount) || 0;
            return aPrice - bPrice;
        });
        const description = (_a = sortedSeats.find(seat => seat.description)) === null || _a === void 0 ? void 0 : _a.description;
        return (React.createElement("div", { className: cn(css.info, css.info_seats) },
            React.createElement("div", { className: css.seats }, sortedSeats.map(renderSeat)),
            description && React.createElement("div", { className: css.description }, description)));
    };
    const renderSeatsInfo = (services, segmentIndex) => {
        const servicesMap = new Map();
        services.forEach(service => {
            var _a;
            const key = `${service.comfort}/${service.serviceClass}`;
            servicesMap.set(key, [...((_a = servicesMap.get(key)) !== null && _a !== void 0 ? _a : []), service]);
        });
        return (React.createElement(React.Fragment, null, [...servicesMap.entries()].map(([key, services]) => (React.createElement(SeatInfo, { key: key, amenities: [], seatService: services[0], segmentId: segmentIndex.toString(), renderHeader: renderSeatInfoHeader(services) })))));
    };
    return React.createElement(SeatMapService, Object.assign({}, props, { renderSeatsInfo: renderSeatsInfo }));
};
export default SeatMap;
